<template>
  <div class="sun not-full SectionFaq">
    <div class="title">자주하는 질문</div>
    <div class="list">
      <div class="item" v-for="(item, index) in list" :key="index">
        <div class="q">Q</div>
        <div class="content">
          <div class="question">
            {{ item.question }}
          </div>
          <div class="line"></div>
          <div class="answer" v-html="item.answer"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionFaq',
  components: {},
  props: {},
  data: function () {
    return {
      list: [
        {
          question: '펀다나우는 어떤 서비스 인가요?',
          answer:
            '펀다나우 서비스는 상점에서 발생하는 일 평균 카드 매출을 분석해 구독 상품에 따라 <b>4일 ~ 최대 14일치 한도를 마이너스 통장</b>처럼 한도 내 에서 수시로 이용할 수 있는 서비스로 많은 자영업자님들이 이용 중입니다.',
        },
        {
          question: '상환 방식은 어떻게 되나요?',
          answer:
            '상환 방식은 원리금 균등상환방식으로 진행이 됩니다. 상환은 입금 받은 다음날 부터 <b> 매일 입금되는 카드매출의 25%</b>씩 상환이 되며, 남은 차액은 고객님의 계좌로 반환이 됩니다.',
        },
        {
          question: '신청 조건에 기준이 있나요?',
          answer:
            '현재 운영중인 사업장에서 꾸준히 <b>카드매출</b>이 발생이 되어야 하며, <b>신용평점 390점 이상</b> 일 경우 신청이 가능 합니다.<br/>' +
            '※ 단, 상점주의 <b>개인 회생/신용 회복/파산/현재 연체</b> 와 같은 신용상 불량 정보가 확인 될 경우 진행에 제한이 있을 수 있습니다.',
        },
        {
          //   question: '진행시 필요한 서류는 뭐가 있나요 ?',
          //   answer: '펀다나우 상품은 펀다와 제휴되어있는 은행계좌로 카드매출 결제 계좌를 변경하는 방식으로 진행이 되어 해당 은행의 계좌가 없으실 경우 비대면 계좌 개설을 통한 진행을 도와드리고 있습니다.<br/>' +
          //     '따라서 펀다나우 서비스 진행시 필요 한 서류는 <b>[ 사업자등록증 사본 / 상점주 신분증 / 본인인증 가능한 휴대폰 / 통장사본 ]</b> 만 있으시면 간편하게 유선상 으로도 진행이 가능 합니다.'
          // }, {
          question: '서비스 신청을 했는데 금액 입금은 언제 되는건가요?',
          answer:
            '펀다에서 진행되는 상품은 펀다의 자금을 대출해 드리는 상품이 아닌, 투자자로부터 자금을 모집해 대출 실행이 됩니다. 펀다나우 서비스의 경우 <b>평일 기준 신청일 다음날 16시 이후</b> 부터 순차적으로 송금 진행이 됩니다.',
        },
        {
          //   question: '중도 상환이 가능 한가요 ? 가능하다면 혹시 중도상환 수수료는 있나요 ?',
          //   answer: '중도 상환 수수료는 별도 발생되지 않으며, 중도상환은 오전 11시 까지 입금되는 금액에 대해서 처리가 가능하며 11시 이후 입금될 경우 1일치 이자가 부과될 수 있습니다.'
          // }, {
          //   question: '이번달 이용 하고 다음달 사용 안하면 이용료는 자동으로 매달 빠져나가는건가요 ?',
          //   answer: '아닙니다. 구독료는 고객님께서 사용하시는 달 첫 번째 입금 받으시는 금액에서 구독료와 부가세 10% 를 제외하고 입금을해 드리며, 다음달 미 이용시 구독료는 부과되지 않습니다.<br/>' +
          //     '즉, 상품 가입 이후 이용하시는 달에만 구독료를 수취합니다.'
          // }, {
          question: '펀다나우 상품 이용시 마다 신용상 이력으로 등재되나요?',
          answer:
            '펀다나우 서비스는 자영업자만 이용할 수 있는 마이너스 통장 개념으로 한도 내 대출로 신용 정보상 등록이 됩니다. 따라서 수시로 이용해도 많은 이력이 남지 않기 때문에 큰 영향을 미치지 않습니다.',
        },
      ],
    }
  },
  computed: {},
  async created() {},
  destroyed() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.SectionFaq {
  padding-top: 60px;
  padding-bottom: 30px;
  float: left;

  .title {
    width: 100%;
    font-weight: 800;
    font-size: 25px;
    letter-spacing: 0.08px;
    text-align: center;
    color: #333333;
  }

  .item {
    margin-top: 30px;
    .q {
      width: 14px;
      height: 20px;
      float: left;
      font-weight: 800;
      font-size: 18px;
      text-align: center;
      color: #1baaf1;
    }
    .content {
      width: calc(100% - 21px);
      float: left;
      margin-left: 7px;
      .question {
        font-weight: 800;
        font-size: 17px;
        line-height: 1.35;
        letter-spacing: -0.5px;
        color: #333333;
      }
      .line {
        width: 100%;
        height: 1px;
        background: #d7e1ea;
        margin-top: 12px;
        margin-bottom: 11px;
      }
      .answer {
        font-weight: 500;
        font-size: 15px;
        /*line-height: 1.47;*/
        line-height: 1.55;
        letter-spacing: -0.5px;
        color: #727d8c;
      }
    }
  }
}
</style>
